module.exports = __webpack_public_path__ + "static/media/guatemala.99bc9280.png";